import styled from '@emotion/styled/macro'

import { pageContentDefaultSize } from 'style/emotion'

const DocsContainer = styled('div')`
  ${pageContentDefaultSize}

  > h2 {
    margin-bottom: 24px;
  }
`

export { DocsContainer }
